// ADA fixes for the site

export function initSkipLink() {
	const skipLink = document.querySelector('.skip-link');

	if (!skipLink) {
		return;
	}

	skipLink.addEventListener('click', function (event) {
		const targetId = skipLink.getAttribute('href');

		if (!targetId || targetId.charAt(0) !== '#') {
			return;
		}

		const target = document.querySelector(targetId);

		if (!target) {
			return;
		}

		event.preventDefault();

		const focusTarget = target.querySelector('h1') || target;

		if (!focusTarget.hasAttribute('tabindex')) {
			focusTarget.setAttribute('tabindex', '-1');
		}

		focusTarget.focus();
		focusTarget.scrollIntoView({ block: 'start' });
		history.pushState(null, '', targetId);
	});
}